import { useYearPeriodStore } from '../../store/useYearPeriodStore'
import { Spinner } from '@heroui/react'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { YearPeriodPicker } from './shared/YearPeriodPicker'
import { MlyGrid } from './shared/MlyGrid'
import { TableOrientationToggle } from './shared/TableOrientationToggle'
import { withShortLabels } from './shared/rowGroupsTransposed'
import { useTableOrientationStore } from '../../store/useTableOrientationStore'
import { useMonthlyData } from '../../hooks/useMonthlyData'
import { useMonthlyNormals } from '../../hooks/useMonthlyNormals'

const SLUG = 'mly-svit'

const ROW_GROUPS = [
  {
    label: 'Sluneční svit',
    rows: [
      { tsId: 'SUNSHINESUM_SUM', label: 'Délka slunečního svitu', unit: 'hod',   normalMode: 'pct',  decimals: 1 },
      { tsId: 'SUNSHINESUM_MAX', label: 'Denní maximum svitu',     unit: 'hod',   normalMode: null,   decimals: 1 },
    ],
  },
  {
    label: 'Globální záření',
    rows: [
      { tsId: 'GLOBALRADSUM_SUM', label: 'Úhrn globálního záření', unit: 'kJ/m²', normalMode: 'pct', decimals: 0 },
      { tsId: 'GLOBALRADSUM_MAX', label: 'Denní maximum záření',    unit: 'kJ/m²', normalMode: null,  decimals: 0 },
    ],
  },
  {
    label: 'Oblačnost',
    rows: [
      { tsId: 'CLOUDAVG_AVG', label: 'Průměrná oblačnost',              unit: 'okty', normalMode: 'diff', decimals: 1 },
      { tsId: 'CLOUDAVG_G8',  label: 'Zatažené dny (oblačnost > 8)',    unit: 'dny',  normalMode: 'diff', decimals: 0 },
      { tsId: 'CLOUDAVG_L2',  label: 'Jasné dny (oblačnost < 2)',       unit: 'dny',  normalMode: 'diff', decimals: 0 },
    ],
  },
]

// 2. definice hlavičky – transponovaná tabulka.
const ROW_GROUPS_T = withShortLabels(ROW_GROUPS, {
  SUNSHINESUM_SUM: 'Délka svitu', SUNSHINESUM_MAX: 'Denní max.',
  GLOBALRADSUM_SUM: 'Úhrn', GLOBALRADSUM_MAX: 'Denní max.',
  CLOUDAVG_AVG: 'Průměr', CLOUDAVG_G8: 'Zatažené (> 8)', CLOUDAVG_L2: 'Jasné (< 2)',
})

const TS_IDS = ROW_GROUPS.flatMap(g => g.rows.map(r => r.tsId))

export function MlySvitView({ station }) {
  const { year, setYear } = useYearPeriodStore()
  const orientation = useTableOrientationStore((s) => s.getOrientation(SLUG))

  const { dataMap, yearMap, dtMap, yearDtMap, isLoading: dLoading, isError: dError } = useMonthlyData(station?.gh_id, year, TS_IDS)
  const { normalsMap, yearNormalsMap, isLoading: nLoading }        = useMonthlyNormals(station?.gh_id, TS_IDS)

  const isLoading = dLoading || nLoading

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <div className="flex items-center justify-between gap-3">
          <YearPeriodPicker year={year} onYearChange={setYear} obsType="DLY" />
          <TableOrientationToggle slug={SLUG} />
        </div>
      </div>
      <div className="flex-1 min-h-0 p-4 flex flex-col">
        {isLoading && <div className="flex items-center gap-2 text-sm text-gray-500"><Spinner size="sm" /> Načítání dat…</div>}
        {dError && <p className="text-red-500 text-sm">Chyba při načítání dat</p>}
        {!isLoading && !dError && (
          <MlyGrid
            rowGroups={ROW_GROUPS}
            rowGroupsTransposed={ROW_GROUPS_T}
            orientation={orientation}
            dataMap={dataMap}
            yearMap={yearMap}
            dtMap={dtMap}
            yearDtMap={yearDtMap}
            normalsMap={normalsMap}
            yearNormalsMap={yearNormalsMap}
          />
        )}
      </div>
    </div>
  )
}
